function TableBody({ children, ...rest }) {
  return <tbody {...rest}>{children}</tbody>;
}

export default TableBody;
